import React from 'react';
import { useTranslation } from 'react-i18next';

function firstNameOf(fullName) {
  if (!fullName) return '';
  return fullName.trim().split(/\s+/)[0];
}

function WelcomeHeader({ fullName, trial }) {
  const { t } = useTranslation('common');

  const showTrialSubtitle =
    trial?.daysRemaining != null && trial.daysRemaining >= 0 && trial.daysRemaining <= 7;

  return (
    <div className="mb-6">
      <h1 className="text-2xl font-bold text-gray-900">
        {t('dashboard.welcome', { name: firstNameOf(fullName) })}
      </h1>
      {showTrialSubtitle && (
        <p className="mt-1 text-sm font-medium text-orange-600">
          {t('dashboard.trialEndsIn', { days: trial.daysRemaining })}
        </p>
      )}
    </div>
  );
}

export default WelcomeHeader;